export default __webpack_public_path__ + "static/media/bonus-1.1ed83083.png";